/**
 * Import required libraries
 */
import React from "react";

/**
 * Import required elements
 */
// Material-ui components
import { Button } from "@material-ui/core";
import styles from "./styles";
import { Alert, CloseIcon } from "Components";
import labels from "./labels";

const ProjectButton = props => {
  const { uid, opened, name } = props;

  const classes = styles(props);

  return (
    <Button className={classes.button}
      size="small"
      disableFocusRipple={opened}
      disableRipple={opened}
      onClick={e => opened ? null : props.click(e, uid)}
      // style={opened  ? {
      //   cursor: "default"
      // } : {
      //   opacity: 0.8,
      // }}
    >
      {name}
    </Button>
  )
}

/**
 * ProjectNavbar Render JSX
 */
const ProjectNavbar = props => {
  let {
    lang,
    projects,
    projectUid,
    navigation,
    colorButtonOnProjectBar,
    clickProject,
    closeProject,
    alert,
    cancelClose,
    confirmClose
  } = props;

  // CSS classnames
  const classes = styles(props);

  return (
    <div className={classes.flex}>
      {projects.map(({ uid, name }, nb) => {
        console.log(`button ${nb} : project ${uid} (selected : ${projectUid === uid})`)
        return (
          <div className={classes.relative} key={uid}>
            <ProjectButton
              uid={uid}
              name={name}
              opened={projectUid === uid && navigation === "project"}
              click={clickProject}
            />
            {/* <CloseIcon className={classes.icon}
              onClick={e => confirmClose(e, uid)}
            /> */}
            {/* <Alert
              open={alert}
              title={labels.title[lang]}
              text={labels.text[lang]}
              actions={actions(uid)}
            /> */}
          </div>
        );
      })}
    </div>
  );
};

export default ProjectNavbar;
